var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    { ref: "formRef", staticClass: "form-edit" },
    _vm._l(_vm.components, function (component, index) {
      return _c(
        "div",
        { key: component._uuid },
        [
          _c(`${component.type}-field`, {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.$checkConditionalViewAllow(
                  component,
                  _vm.components,
                  _vm.variables,
                  _vm.json
                ),
                expression:
                  "!$checkConditionalViewAllow(component, components, variables, json)",
              },
            ],
            tag: "component",
            attrs: { component: component, index: index },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }